import type { OrganizationPreferences, OrganizationSettings } from '@examing/types';

// Web mirror of the backend default map (apps/api/src/common/org-preferences.ts).
// Kept as a separate value because the web bundler cannot value-import workspace
// TS. Types are shared from @examing/types (type-only imports are fine).
export const DEFAULT_ORG_PREFERENCES: OrganizationPreferences = {
  notifications: {
    candidateCompletion: true,
    importantEvents: true,
    weeklyDigest: false,
    testFeedback: true,
  },
  ai: {
    gradingSuggestions: true,
    questionGeneration: true,
  },
  // Blind grading is opt-in: default OFF.
  grading: {
    anonymous: false,
  },
};

const pick = (value: unknown, fallback: boolean): boolean =>
  typeof value === 'boolean' ? value : fallback;

// Resolve a stored (possibly empty/partial) settings bag into concrete
// preferences. Mirrors resolveOrgPreferences on the backend.
export const resolveOrgPreferences = (
  settings?: OrganizationSettings | Record<string, unknown> | null,
): OrganizationPreferences => {
  const notifications = (settings?.notifications ?? {}) as Record<string, unknown>;
  const ai = (settings?.ai ?? {}) as Record<string, unknown>;
  const grading = (settings?.grading ?? {}) as Record<string, unknown>;
  const d = DEFAULT_ORG_PREFERENCES;
  return {
    notifications: {
      candidateCompletion: pick(notifications.candidateCompletion, d.notifications.candidateCompletion),
      importantEvents: pick(notifications.importantEvents, d.notifications.importantEvents),
      weeklyDigest: pick(notifications.weeklyDigest, d.notifications.weeklyDigest),
      testFeedback: pick(notifications.testFeedback, d.notifications.testFeedback),
    },
    ai: {
      gradingSuggestions: pick(ai.gradingSuggestions, d.ai.gradingSuggestions),
      questionGeneration: pick(ai.questionGeneration, d.ai.questionGeneration),
    },
    grading: {
      anonymous: pick(grading.anonymous, d.grading.anonymous),
    },
  };
};
